module.exports = __webpack_public_path__ + "img/schema-v2.105ddb87.png";